import api from '../api/axios.config';

export const productOptionsService = {
  filterBrands: async (sku_code, brand, category, sub_category, subline) => {
    try {
      const params = { };

      if (sku_code) params.sku_code = sku_code;
      if (brand) params.brand = brand;
      if (category) params.category = category;
      if (sub_category) params.sub_category = sub_category;
      if (subline) params.subline = subline;

      const response = await api.get(`/product-filter-options`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

}    